<script setup>
const props = defineProps({
  title: String,
  text: String,
  pageType: {
    type: String,
    default: "",
  },

  
});

const cleanedTitle = computed(() => {
  // Strip outer <p> and </p> only if they wrap the entire content
  return props.title?.replace(/^<p>(.*?)<\/p>$/s, '$1') || '';
});

</script>

<template>
  <section class="hero l-container p-section">
    <div class="prose w-full md:max-w-[75%]">
      <h2
        v-if="pageType === 'project'"
        v-html="title"
        class="h1 hero__title !my-lg"
      ></h2>
      <h1 v-else   v-html="title.replace(/<p>/g, '').replace(/<\/p>/g, '')"
        class="hero__title !my-lg"></h1>

      <div v-if="text" v-html="text" class="text-lg"></div>
    </div>
  </section>
</template>

<style>
</style>
